import createCache from "@emotion/cache";
import { createStyles, makeStyles } from "@material-ui/core";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SearchIcon from "@mui/icons-material/Search";
import {
  Button,
  Grid,
  IconButton,
  InputBase,
  Pagination,
  PaginationItem,
  Paper,
  Typography,
} from "@mui/material";
import { createTheme } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import debounce from "lodash/debounce";
import * as React from "react";
import { useCallback, useEffect, useState } from "react";
import { useMutation, useQueryClient } from "react-query";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import { MAINCATEGORYID, TABLE_FILTER } from "../../config/cacheKey";
import { Filter, PaginationInfo } from "../../models/store.model";
import { GetStoreListReportExcel } from "../../services/store.service";
import ModalCancel from "../../components/modals/ModalCancel";
import ModalAddCategory from "../../components/modals/ModalAddCategory";
import {
  DeleteSubCategory,
  GetCategoriesByMainCategoryId,
  GetSubCategoryById,
} from "../../services/productCategory.service";
import {
  AddMainCategoryRequest,
  GetCategoriesByMainCategoryIdResponse,
  GetSubCategoryByIdResponse,
  SubCategoryById,
} from "../../models/productCategory.model";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutline";
import CategoryHeader from "../supplierSettelments/components/CategoryHeader";

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "title", label: "عنوان زیرگروه" },
  { id: "englishTitle", label: "عنوان انگلیسی" },
  { id: "hexCode", label: "کدرنگ" },
  { id: "sortIndex", label: "ترتیب نمایش" },
  { id: "isActive", label: "وضعیت گروه" },
];

export default function ProductSubgroupTable() {
  const [categoryById, setCategoryById] = useState<
    GetSubCategoryByIdResponse
  >();
  const [searchTerm, setSearchTerm] = useState<string>("");
  const [serviceName, setServiceName] = useState<string>("");
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [subCategoryId, setSubCategoryId] = useState<number>();
  const [filteredData, setFilteredData] = useState<AddMainCategoryRequest[]>(
    []
  );

  const [openAddCategoryModal, setOpenAddCategoryModal] = useState(false);
  // const muiSelected = jsonFile?.secondColor_100;
  const useStyles = makeStyles((theme) =>
    createStyles({
      select: {
        "&.Mui-selected": {
          backgroundColor: "#82B1FF !important",
        },
      },
    })
  );
  const classes = useStyles();
  const [valueFilterData, setValueFilterData] = React.useState<Filter>();

  let row: any;
  const queryClient = useQueryClient();
  const history = useHistory<{
    from: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();
  const [subCategory, setSubCategory] = useState<AddMainCategoryRequest[]>([]);

  const [mainCategoryHeader, setMainCategoryHeader] = useState<
    AddMainCategoryRequest
  >();
  const [selectedRow, setSelectedRow] = useState(undefined);
  const previousPage =
    history.location.state !== undefined ? history.location.state.from : null;

  const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
    (): PageInfoModel => {
      let pageInfoModel = new PageInfoModel();
      pageInfoModel.pageNumber = -1;
      pageInfoModel.pageSize = 1;
      pageInfoModel.total = 0;

      return pageInfoModel;
    }
  );
  const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
    (): PaginationInfo => {
      let paginationInfo = new PaginationInfo();
      paginationInfo.pageNumber =
        history.location.state != undefined
          ? history.location.state.pageNumber
          : 1;
      return paginationInfo;
    }
  );

  let mainCategoryId;
  React.useEffect(() => {
    mainCategoryId = localStorage.getItem(MAINCATEGORYID);
    GetCategoriesByMainCategoryIdMutation({
      mainCategoryId: parseInt(mainCategoryId!),
    });
    let filterData;
    if (
      previousPage !== null ||
      (history.action === "REPLACE" &&
        history.location.state !== undefined &&
        history.location.state.clickOnBack)
    ) {
      filterData = queryClient.getQueryData<Filter>(TABLE_FILTER);
    } else {
      filterData = null;
      queryClient.setQueryData(TABLE_FILTER, null);
      let filter = new Filter();
      setValueFilterData(filter);
    }
    // fillData(filterData!);
  }, []);

  const { mutateAsync: GetCategoriesByMainCategoryIdMutation } = useMutation(
    GetCategoriesByMainCategoryId,
    {
      onSuccess: (
        data: ApiResultModel<GetCategoriesByMainCategoryIdResponse>
      ) => {
        setFilteredData(data.data.subCategory);
        setSubCategory(data.data.subCategory);
        setMainCategoryHeader(data.data.mainCategory);
      },
    }
  );
  const { mutateAsync: GetSubCategoryByIdMutation } = useMutation(
    GetSubCategoryById,
    {
      onSuccess: (data: ApiResultModel<GetSubCategoryByIdResponse>) => {
        setCategoryById(data.data);
        setOpenAddCategoryModal(true);
        setServiceName("UpdateSubCategory");
      },
    }
  );

  const { mutateAsync: DeleteSubCategoryMutate } = useMutation(
    DeleteSubCategory,
    {
      onSuccess: (data: ApiResultModel<boolean>) => {
        if (data.isSuccess === true) {
          toast.success("زیر گروه با موفقیت حذف شد");
          GetCategoriesByMainCategoryIdMutation({
            mainCategoryId: parseInt(localStorage.getItem(MAINCATEGORYID)!),
          });
          setOpenModal(false);
        } else toast.error(data.data);
      },
    }
  );

  const { mutateAsync: GetStoreListReportExcelMutate } = useMutation(
    GetStoreListReportExcel,
    {
      onSuccess: (result) => {},
      onError: (e) => {},
    }
  );
  const handleDelete = (id: number) => {
    setOpenModal(true);
    setSubCategoryId(id);
  };
  const deleteImage = () => {
    DeleteSubCategoryMutate({ id: subCategoryId! });
  };

  const filter = new Filter();
  const handelDetail = (id: number) => {};
  const handleEditSubCategory = (id: number) => {
    GetSubCategoryByIdMutation({ id: id });
    setServiceName("UpdateSubCategory");
  };

  let exportExcel = () => {
    GetStoreListReportExcelMutate(
      valueFilterData ? valueFilterData! : new Filter()
    );
  };

  const debouncedSearch = useCallback(
    debounce((value: string) => {
      const filtered = subCategory!.filter((category) =>
        columns.some(
          (column) =>
            column.id &&
            category[column.id as keyof SubCategoryById]
              ?.toString()
              .toLowerCase()
              .includes(value.toLowerCase())
        )
      );
      setFilteredData(filtered);
    }, 300),
    [filteredData]
  );
  const handleSearchInput = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
    debouncedSearch(value);
  };

  useEffect(() => {
    GetCategoriesByMainCategoryIdMutation({
      mainCategoryId: parseInt(localStorage.getItem(MAINCATEGORYID)!),
    });
    if (openAddCategoryModal) {
      if (serviceName === "UpdateSubCategory") {
        GetCategoriesByMainCategoryIdMutation({
          mainCategoryId: parseInt(localStorage.getItem(MAINCATEGORYID)!),
        });
      } else {
        setCategoryById(undefined);
      }
    }
  }, [currentPaginationInfo, openAddCategoryModal]);

  // const generateFilter = (filterData: Filter): StorePage => {
  //   let request = {} as StorePage;
  //   request.paginationInfo = currentPaginationInfo;
  //   request.filter = filterData;
  //   return request;
  // };

  // const fillData = (filterData: Filter) => {
  //   let filter = generateFilter(filterData);
  //   GetStoreListMutate(filter);
  //   setValueFilterData(filter?.filter);
  // };

  // const changePageNumber = (newPageNumber: number) => {
  //   const tabelFilter = queryClient.getQueryData<Filter>(TABLE_FILTER);
  //   fillData(tabelFilter!);
  //   currentPaginationInfo.pageNumber = newPageNumber;
  //   setCurrentPaginationInfo(currentPaginationInfo);
  // };

  // const handleChangePagination = (event: any, value: any) => {
  //   changePageNumber(value);
  // };

  return (
    <div>
      <Grid>
        <CategoryHeader headerData={mainCategoryHeader!} />
      </Grid>
      <Grid container spacing={2} style={{ marginTop: "0px" }}>
        <Grid
          item
          xs={12}
          sm={6}
          style={{ alignContent: "center", paddingTop: "0px" }}
        >
          <Button
            onClick={() => {
              setOpenAddCategoryModal(true);
              setServiceName("AddSubCategory");
            }}
          >
            <AddCircleOutlineIcon />
            <span
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                paddingRight: "5px",
              }}
            >
              افزودن زیر گروه جدید
            </span>
          </Button>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          style={{
            placeItems: "end",
            alignContent: "center",
            paddingTop: "0px",
          }}
        >
          <Paper
            sx={{ width: { xs: "100%", sm: "20vw" } }}
            elevation={0}
            style={{
              border: ".9px solid #DAE0E4",
              display: "flex",
              borderRadius: "3px",
              height: "35px",
              marginRight: "10px",
              margin: "10px",
              direction: "rtl",
              marginLeft: "0px",
            }}
            square={true}
          >
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                paddingX: "16px",
                height: "30px !important",
              }}
              placeholder="جستجو"
              onChange={handleSearchInput}
              value={searchTerm}
            />
            <IconButton
              type="button"
              sx={{ color: "#9AAFC4" }}
              aria-label="search"
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Grid>
      </Grid>
      {filteredData && filteredData.length > 0 ? (
        <>
          <div className="cardTableBorder ">
            <TableContainer
              style={{ background: "#fff", direction: "rtl" }}
              className={`${filteredData?.length > 0 ? "boxScrollSubmit" : ""}`}
            >
              <Table
                stickyHeader
                aria-label="sticky table "
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className="rowTHead"
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft`}
                  >
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight"
                      align="right"
                      style={{ width: "5px" }}
                    >
                      ردیف
                    </TableCell>
                    {columns?.map((column) => (
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight nowrapClass"
                        key={column.id}
                        align="right"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight"
                      align="right"
                      style={{ width: "10vh", minWidth: "10vh" }}
                    >
                      <MoreHorizIcon />
                    </TableCell>
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>

                <TableBody
                  style={{
                    height: "30px",
                    minHeight: "30px",
                  }}
                >
                  {filteredData?.map((row, rowIndex) => {
                    return (
                      <TableRow
                        classes={{ root: classes.select }}
                        className={`${
                          rowIndex % 2 == 0
                            ? "rowTBodyE  borderRight borderLeft"
                            : "rowTBodyO  borderRight borderLeft"
                        }${classes} borderRight borderLeft cursorPointer noWrap`}
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        // key={row.loanRequestId}
                        selected={selectedRow === rowIndex}
                      >
                        <TableCell
                          className="textFont12"
                          style={{ width: "5px" }}
                        >
                          {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                            (currentPaginationInfo.pageSize! ?? 0) +
                            rowIndex +
                            1}
                        </TableCell>
                        {columns?.map((column) => {
                          const value = row[column.id as keyof SubCategoryById];
                          return (
                            <TableCell
                              onClick={() => handelDetail(row.id!)}
                              className="textFont12 nowrapClass"
                              key={column.id}
                              align="right"
                            >
                              {column.format && column.hasFormat ? (
                                column.format(value)
                              ) : column.id === "isActive" ? (
                                value === true ? (
                                  <b
                                    style={{
                                      color: "#28A745",
                                    }}
                                  >
                                    فعال
                                  </b>
                                ) : (
                                  <b
                                    style={{
                                      color: "#E6123D",
                                    }}
                                  >
                                    غیرفعال
                                  </b>
                                )
                              ) : (
                                value?.toString()
                              )}
                            </TableCell>
                          );
                        })}
                        <TableCell
                          className="textFont12"
                          sx={{ textAlign: "end !important" }}
                        >
                          <EditOutlinedIcon
                            sx={{
                              color: "#1D4A87",
                              fontSize: "1.8rem",
                              cursor: "pointer",
                              marginInline: "8px",
                            }}
                            onClick={() => {
                              handleEditSubCategory(row.id!);
                            }}
                          />
                          <DeleteOutlineOutlinedIcon
                            onClick={() => handleDelete(row.id!)}
                            style={{
                              color: "#1D4A87",
                              cursor: "pointer",
                              marginInline: "3px",
                            }}
                          />
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {/* <div className="row"></div>
        <Grid container xs={12}>
          <Grid item xs={4}>
            <span
              style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
            >
              تعداد کل :
              <span style={{ color: "#01AF43" }}>{pageInfo.total}</span> مورد
            </span>
          </Grid>
          <Grid item xs={4}>
            <Pagination
              renderItem={(item) => (
                <PaginationItem
                  components={{
                    previous: previusIcon,
                    next: nextIcon,
                  }}
                  {...item}
                />
              )}
              // color="primary"
              sx={{
                display: "flex",
                justifyContent: "center !important",
                direction: "ltr",
                margin: "5px",
                button: {
                  color: "#25D1C9",
                  fontSize: "14px !important",
                  fontFamily: "iranSans",
                },
                //  button.sele
              }}
              count={Math.ceil(pageInfo.total / pageInfo.pageSize)}
              onChange={handleChangePagination}
              page={currentPaginationInfo.pageNumber}
            />
          </Grid>
          <Grid item xs={4}></Grid>
        </Grid> */}
        </>
      ) : (
        <div
          style={{
            backgroundColor: "#F9FCFE",
            border: "#DAE0E4",
            height: " calc(90vh - 22vh)",
            textAlign: "center",
            alignContent: "center",
          }}
        >
          <div>
            <img
              src="/images/nouser.jpg"
              alt="no user"
              style={{ width: "10%", height: "10%" }}
            />
          </div>
          <Typography style={{ color: "#9AAFC4", fontSize: "20px" }}>
            کاربری ثبت نشده است
          </Typography>
        </div>
      )}
      {openModal === true ? (
        <ModalCancel
          title={""}
          bgColor={"kamanColor"}
          setValue={deleteImage}
          openModal={openModal}
          setOpenModal={setOpenModal}
        />
      ) : (
        ""
      )}
      {openAddCategoryModal === true ? (
        <ModalAddCategory
          openCategoryModal={openAddCategoryModal}
          setOpenCategoryModal={setOpenAddCategoryModal}
          modalTitle="افزودن زیر گروه جدید"
          textfieldTitle="عنوان زیر گروه"
          serviceName={serviceName}
          MainCategoryId={parseInt(localStorage.getItem(MAINCATEGORYID)!)}
          categoryById={categoryById}
        />
      ) : null}
    </div>
  );
}
